import {Card, Nav} from "react-bootstrap";
import ProgressionButtons from "../../SubCompounents/ProgressionButtons";
import PieChart from "../../SubCompounents/PieChart";
import {Equalizer} from "@material-ui/icons";
import React from "react";
import './Exams.css'
import '../../css/siamois.css'
import './Recapitulatif.css'
import {useSelector} from "react-redux";
import {PieChartLoader, QuestionTypeLoader , QuestionNameLoader} from "./SkeletonLoaders/Loaders";
import {useMediaQuery} from "@material-ui/core";

export const RecaputalitifRevision=({})=>{
    const revision=useSelector(state=>state.revision);
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    return (
        <Card id="recapitulatifCard" >
            {/*The question Header for the mobiles in the sidebar*/}
            <Card.Header className="d-lg-none"> <Card.Title className="pt-3 pb-1" style={{ color : 'var(--info)' , textAlign : 'center'}} id="questionInfo">ECH normal et pathologique <br/>- Q 1/22</Card.Title></Card.Header>

            <Card.Header className=" border-0 pb-0">
                <Card.Title>Progression</Card.Title>
            </Card.Header>
            <Card.Body id="progressionCard">
                {!revision.loading ? <Nav id="ProgressionButtons"><ProgressionButtons  size={""} gutter={true}  variant="" bg={true}  circle={true}  /></Nav> :
                    <div className="d-flex justify-content-center w-100">
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                    </div>
                }
            </Card.Body>
            <Card.Header className=" border-0 pb-0">
                <Card.Title>Recapitulatif</Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="card-body text-center pt-2 pb-2">
                    { revision.loading ? <PieChartLoader/> :
                        <React.Fragment>
                            <div className="man-chart">
                                <PieChart height={200} data={[55,55,55,55]} colors={['var(--success)' ,'var(--danger)' , 'var(--warning)' , 'var(--info)']} labels={['Juste' , 'Fausse' , 'Sans Réponse' , 'Non Visitée']} width={100} height={400}  />
                                <Equalizer className="pieChartIcon" style={{fontSize : 60 , color : 'var(--info)'}}/>
                            </div>
                        </React.Fragment>
                    }

                </div>
            </Card.Body>
        </Card>
    )
};


export const RecaputalitifExamen=()=>{
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');

    const examen = useSelector(state=>state.examen);
    return (
        <Card>
            {/*The question Header for the mobiles in the sidebar*/}
            <Card.Header className="d-lg-none"> <Card.Title className="pt-3 pb-1" style={{ color : 'var(--info)' , textAlign : 'center'}} id="questionInfo">{examen.loading ? <QuestionNameLoader/> :  `ECH normal et pathologique <br/>- Q 1/22`}</Card.Title></Card.Header>
            <Card.Header className=" border-0 pb-0">
                <Card.Title>Progression</Card.Title>
            </Card.Header>
            <Card.Body id="progressionCard">
                {!examen.loading ? <Nav id="ProgressionButtons">{ProgressionButtons("", true, "", true, true)}</Nav> :
                    <div className="d-flex justify-content-center w-100">
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                        <QuestionTypeLoader/>
                    </div>
                }
            </Card.Body>
            <Card.Header className=" border-0 pb-0">
                <Card.Title>Recapitulatif</Card.Title>
            </Card.Header>
            <Card.Body>
                <div style={lg ? {} : {marginLeft : '-5rem'}}  className="card-body text-center pt-2 pb-2">
                    { examen.loading ? <PieChartLoader/> :
                        <React.Fragment>
                            <div className="man-chart">
                                <PieChart height={200} data={[55,55,55]} colors={['var(--success)' ,'var(--danger)' , 'var(--warning)']} labels={['Rèpondues' , 'Sautées' ,'Non Visitée']} width={100} height={400}  />
                                <Equalizer className="pieChartIcon" style={{fontSize : 60 , color : 'var(--info)'}}/>
                            </div>
                        </React.Fragment>
                    }

                </div>
            </Card.Body>
        </Card>
    )
};
